import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';
import Calendar from '../shared/calendar/main';
import CurrenciesSelectForm from './components/currencies-select-form';
import BalancesReportForm from './components/balances-report-form';
import Filters from '../shared/filters/main';

import { selectors as rootSelectors } from '../root';

const Main = renderViewsState(
	props => (
		<Animate>
			<div className="container__content fin-reports">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<h1 className="title">{props.intl('Financial reports')}</h1>
					</div>
				</div>
				<div className="container__content-body">
					<div className="ui-control-bar">
						<div className="ui-control-bar__item modify-item---calendar">
							<div className="ui-control-bar__item-position">
								<Calendar
									{...props.calendar}
									onInit={props.calendarInit}
									onToggle={props.calendarToggle}
									onChange={props.calendarChange}
									onApply={props.calendarApply}
									intl={props.intl}
								/>
							</div>
						</div>

						<div className="ui-control-bar__item modify-item---currency">
							<div className="ui-control-bar__item-position">
								<CurrenciesSelectForm
									{...props}
									initialValues={{'currency': [
										{ label: 'usd', value: 'usd' },
										{ label: 'eur', value: 'eur' },
										{ label: 'rub', value: 'rub' }
									]}}
									enableReinitialize={true}
								/>
							</div>
						</div>

						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								<button
									className="ui-btn ui-btn-primary apply"
									onClick={props.getReport.bind(null, 'balances-movement', false)}
								>
									{props.intl('Balances movement')}
								</button>
								<button
									className="ui-btn ui-btn-primary apply"
									onClick={props.getReport.bind(null, 'conversions', false)}>
									{props.intl('Conversions')}
								</button>
								{
									props.can('manualAdjustmentsView') &&
									<button
										className="ui-btn ui-btn-primary apply"
										onClick={props.getReport.bind(null, 'manual-adjustments', false)}>
										{props.intl('Manual adjustments')}
									</button>
								}
								<button
									className="ui-btn ui-btn-primary apply"
									onClick={props.getReport.bind(null, 'increase-approve', false)}>
									{props.intl('Increased Approve')}
								</button>
							</div>
						</div>
					</div>
					<div>
						<div className="ui-control-bar download-accruals">
							<div className="fin_reports-conversions clearfix">
								<Filters {...props} {...props.filters} />
							</div>
							<div className="download-accruals_buttons-container">
								<div className="display-flex">
									<Calendar
										{...props.accrualReportCalendar}
										onInit={props.accrualReportCalendarInit}
										onToggle={props.accrualReportCalendarToggle}
										onChange={props.accrualReportCalendarChange}
										onApply={props.accrualReportCalendarApply}
										intl={props.intl}
									/>
									<button
										className="ui-btn ui-btn-primary apply"
										onClick={() => props.getFinancialReports('accruals-reports')}>
										{props.intl('Transaction reports')}
									</button>
									<button
										className="ui-btn ui-btn-primary apply"
										onClick={() => props.getFinancialReports('payout-reports')}>
										{props.intl('Payout reports')}
									</button>
								</div>
								<BalancesReportForm {...props}/>
							</div>

						</div>
					</div>
				</div>
			</div>
		</Animate>
	),
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		calendar: selectors.getCalendar(state),
		datepicker: selectors.getDatepicker(state),
		accrualReportCalendar: selectors.getAccrualReportCalendar(state),
		listOfCurrencies: selectors.getListOfCurrencies(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		filters: selectors.getFilters(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/fin-reports/main.js